import { render, staticRenderFns } from "./DocumentsSheetDemo.vue?vue&type=template&id=1257f9ea&scoped=true"
import script from "./DocumentsSheetDemo.vue?vue&type=script&lang=js"
export * from "./DocumentsSheetDemo.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSheetDemo.vue?vue&type=style&index=0&id=1257f9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1257f9ea",
  null
  
)

export default component.exports